module.exports = __webpack_public_path__ + "static/img/logo-tourhouse-md.f075ed0c.png";